import React, { useCallback, useEffect, useRef, useState } from 'react';

import axios from 'axios';

import { Button, Form, Spinner } from 'react-bootstrap';

import {

  FaIdCard,

  FaLock,

  FaCheckCircle,

  FaCheck,

  FaArrowRight,

  FaShieldAlt,

  FaHome,

  FaPhoneAlt,

  FaChevronDown,

} from 'react-icons/fa';

import { Link } from 'react-router-dom';

import applyNowImage from '../assets/images/apply-new-side.jpg';

import { getFallbackCities } from '../utils/stateCityMapping';

import {
  apiSendOtp,
  apiText,
  panVerifyFailMessage,
  apiVerifyOtp,
  checkExistingCustomerByPan,
  checkPanBlacklist,
  getCities,
  getPincodesByCityId,
  getStates,
  saveLendingPage,
  verifyPan,
} from '../config/applyNewDirectApi';

import {

  clearPanCache,

  getPanCache,

  isLeadSaveSuccess,

  isPanVerifySuccess,

  setPanCache,

} from '../config/taskApi';

import './apply-new.css';

const APPLY_DRAFT_KEY = 'apply_new_draft_v1';

const readApplyDraft = () => {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.localStorage.getItem(APPLY_DRAFT_KEY);
    if (!raw) return null;
    const draft = JSON.parse(raw);
    return draft && typeof draft === 'object' ? draft : null;
  } catch (error) {
    console.warn('Unable to restore Dhanwalle application data:', error);
    return null;
  }
};

const clearApplyDraft = () => {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.removeItem(APPLY_DRAFT_KEY);
  } catch (error) {
    console.warn('Unable to clear Dhanwalle application data:', error);
  }
};

const getOtpResumeState = (sentAt, wasSent = false) => {
  const timestamp = Number(sentAt) || 0;
  if (!timestamp) return { sent: Boolean(wasSent), remaining: 0 };
  const elapsed = Math.floor((Date.now() - timestamp) / 1000);
  return {
    sent: Boolean(wasSent),
    remaining: Math.max(0, OTP_RESEND_SECONDS - elapsed),
  };
};

const PAN_PATTERN = /^[A-Z]{5}[0-9]{4}[A-Z]$/;

const MIN_LOAN_AMOUNT = 10000;

const MAX_LOAN_AMOUNT = 100000;

const MIN_MONTHLY_INCOME = 30000;

const MAX_MONTHLY_INCOME = 5000000;

const MAX_OBLIGATIONS = 5000000;

const MIN_ADDRESS_LENGTH = 15;

const MAX_ADDRESS_LENGTH = 500;

const OTP_RESEND_SECONDS = 60;

const emptyProfile = {

  firstName: '',

  middleName: '',

  lastName: '',

  dob: '',

  gender: '',

  addressFromKyc: '',

  maskedAadhaar: '',

  panName: '',

};

function splitFullName(fullName = '') {

  const parts = String(fullName).trim().split(/\s+/).filter(Boolean);

  if (!parts.length) return { firstName: '', middleName: '', lastName: '' };

  if (parts.length === 1) return { firstName: parts[0], middleName: '', lastName: '' };

  if (parts.length === 2) {

    return { firstName: parts[0], middleName: '', lastName: parts[1] };

  }

  return {

    firstName: parts[0],

    middleName: parts.slice(1, -1).join(' '),

    lastName: parts[parts.length - 1],

  };

}

function SearchableSelect({

  label,

  required,

  value,

  displayValue,

  options,

  placeholder,

  disabled,

  error,

  fieldName,

  onSelect,

  getOptionLabel,

  getOptionValue,

}) {

  const [open, setOpen] = useState(false);

  const [query, setQuery] = useState('');

  const wrapRef = useRef(null);

  useEffect(() => {

    const onDoc = (e) => {

      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);

    };

    document.addEventListener('mousedown', onDoc);

    return () => document.removeEventListener('mousedown', onDoc);

  }, []);

  const filtered = options.filter((opt) =>

    String(getOptionLabel(opt) || '')

      .toLowerCase()

      .includes(query.toLowerCase())

  );

  return (

    <div className="apn-field" ref={wrapRef} data-field={fieldName || undefined}>

      <label>

        {label} {required ? <em>*</em> : null}

      </label>

      <div className={`apn-search-select ${error ? 'has-error' : ''} ${disabled ? 'is-disabled' : ''}`}>

        <input

          type="text"

          disabled={disabled}

          placeholder={placeholder}

          value={open ? query : displayValue || ''}

          onFocus={() => {

            if (disabled) return;

            setOpen(true);

            setQuery('');

          }}

          onChange={(e) => {

            setQuery(e.target.value);

            setOpen(true);

          }}

          autoComplete="off"

        />

        <FaChevronDown className={`apn-dropdown-ico ${open ? 'is-open' : ''}`} />

      </div>

      {open && !disabled && (

        <div className="apn-search-menu">

          {filtered.length === 0 && <div className="apn-search-empty">No results</div>}

          {filtered.map((opt) => {

            const id = getOptionValue(opt);

            return (

              <button

                type="button"

                key={id}

                className={String(id) === String(value) ? 'active' : ''}

                onClick={() => {

                  onSelect(opt);

                  setOpen(false);

                  setQuery('');

                }}

              >

                {getOptionLabel(opt)}

              </button>

            );

          })}

        </div>

      )}

      {error ? <div className="apn-error">{error}</div> : null}

    </div>

  );

}

const ApplyNew = () => {

  const savedDraftRef = useRef(undefined);
  if (savedDraftRef.current === undefined) {
    savedDraftRef.current = readApplyDraft();
  }
  const savedDraft = savedDraftRef.current;
  const storageReadyRef = useRef(false);
  const otpResume = getOtpResumeState(savedDraft?.otpSentAt, savedDraft?.otpSent);

  const [panNumber, setPanNumber] = useState(() => savedDraft?.panNumber || '');

  const [mobileOtpVerified, setMobileOtpVerified] = useState(() => Boolean(savedDraft?.mobileOtpVerified));

  const [otpInfo, setOtpInfo] = useState('');

  const [digilockerLoading, setDigilockerLoading] = useState(false);

  const [kycLoading, setKycLoading] = useState(false);

  const [digilockerError, setDigilockerError] = useState('');

  const [otp, setOtp] = useState('');

  const [otpSent, setOtpSent] = useState(() => otpResume.sent && !savedDraft?.mobileOtpVerified);

  const [otpVerified, setOtpVerified] = useState(() => Boolean(savedDraft?.otpVerified));

  const [resendLeft, setResendLeft] = useState(() => (savedDraft?.mobileOtpVerified ? 0 : otpResume.remaining));
  const [otpSentAt, setOtpSentAt] = useState(() => Number(savedDraft?.otpSentAt) || 0);

  const [panBlacklisted, setPanBlacklisted] = useState(() => Boolean(savedDraft?.panBlacklisted));

  const [panBlocked, setPanBlocked] = useState(() => Boolean(savedDraft?.panBlocked));

  const [panWarning, setPanWarning] = useState(() => savedDraft?.panWarning || '');

  const [panVerifiedOk, setPanVerifiedOk] = useState(() => Boolean(savedDraft?.panVerifiedOk));

  const [panChecking, setPanChecking] = useState(false);

  const [otpBusy, setOtpBusy] = useState(false);

  const [errors, setErrors] = useState({});

  const [profile, setProfile] = useState(() => ({ ...emptyProfile, ...(savedDraft?.profile || {}) }));

  const [panVerifyPayload, setPanVerifyPayload] = useState(() => savedDraft?.panVerifyPayload || null);

  const [states, setStates] = useState([]);

  const [cities, setCities] = useState([]);

  const [pincodes, setPincodes] = useState([]);

  const [stateId, setStateId] = useState(() => savedDraft?.stateId ? String(savedDraft.stateId) : '');

  const [cityId, setCityId] = useState(() => savedDraft?.cityId ? String(savedDraft.cityId) : '');

const [form, setForm] = useState(() => {
    const initialForm = {
      monthlyIncome: '',
      loanAmount: '',
      mobile: '',
      alternateMobile: '',
      email: '',
      officialEmail: '',
      obligations: '',
      state: '',
      city: '',
      pincode: '',
      address: '',
      declarationConsent: false,
      notificationConsent: false,
    };

    return {
      ...initialForm,
      ...(savedDraft?.form || {}),
    };
  });

  const [submitting, setSubmitting] = useState(false);

  const [submitted, setSubmitted] = useState(false);

  const [kycCompleted, setKycCompleted] = useState(() => Boolean(savedDraft?.kycCompleted));

  const [refId, setRefId] = useState('');

  const submitLockRef = useRef(false);

  const verifiedOtpRef = useRef(
    typeof window !== 'undefined' ? sessionStorage.getItem('dhanwalle_apply_new_verified_otp') || '' : ''
  );

  const panReqRef = useRef({ id: 0, pan: '', busy: false });

useEffect(() => {
    storageReadyRef.current = true;
  }, []);

  useEffect(() => {
    if (!storageReadyRef.current || submitted) return;

    const draft = {
      form,
      panNumber,
      profile,
      stateId,
      cityId,
      mobileOtpVerified,
      // Never persist the OTP itself.
      otpSent: mobileOtpVerified ? false : otpSent,
      otpSentAt: mobileOtpVerified ? 0 : otpSentAt,
      otpVerified,
      kycCompleted,
      panVerifyPayload,
      panVerifiedOk,
      panBlacklisted,
      panBlocked,
      panWarning,
      updatedAt: Date.now(),
    };

    try {
      window.localStorage.setItem(APPLY_DRAFT_KEY, JSON.stringify(draft));
    } catch (error) {
      console.warn('Unable to save Dhanwalle application data:', error);
    }
  }, [
    form,
    panNumber,
    profile,
    stateId,
    cityId,
    mobileOtpVerified,
    otpSent,
    otpSentAt,
    otpVerified,
    kycCompleted,
    panVerifyPayload,
    panVerifiedOk,
    panBlacklisted,
    panBlocked,
    panWarning,
    submitted,
  ]);

  useEffect(() => {

    getStates()

      .then((data) => {

        if (data?.Status === 1 && Array.isArray(data.Data)) setStates(data.Data);

      })

      .catch(() => { });

  }, []);

  useEffect(() => {
    let cancelled = false;

    const restoreLocationOptions = async () => {
      if (stateId && form.state) {
        try {
          const cityResponse = await getCities(String(stateId));
          if (cancelled) return;
          if (cityResponse?.Status === 1 && Array.isArray(cityResponse.Data) && cityResponse.Data.length) {
            setCities(cityResponse.Data);
          } else {
            setCities(getFallbackCities(form.state));
          }
        } catch {
          if (!cancelled) setCities(getFallbackCities(form.state));
        }
      }

      if (cityId && !String(cityId).startsWith('local-')) {
        try {
          const pincodeResponse = await getPincodesByCityId(String(cityId));
          if (!cancelled && pincodeResponse?.Status === 1 && Array.isArray(pincodeResponse.Data)) {
            setPincodes(pincodeResponse.Data);
          }
        } catch {
          if (!cancelled) setPincodes([]);
        }
      }
    };

    restoreLocationOptions();
    return () => { cancelled = true; };
  }, []);

  useEffect(() => {

    if (resendLeft <= 0) return undefined;

    const t = setInterval(() => setResendLeft((s) => Math.max(0, s - 1)), 1000);

    return () => clearInterval(t);

  }, [resendLeft]);

  const runPanChecks = useCallback(async (pan) => {

    if (!PAN_PATTERN.test(pan)) return;

    if (panReqRef.current.pan === pan && (panReqRef.current.busy || panReqRef.current.done)) return;

    const reqId = panReqRef.current.id + 1;

    panReqRef.current = { id: reqId, pan, busy: true, done: false };

    const isCurrent = () => panReqRef.current.id === reqId;

    setPanChecking(true);

    setPanWarning('');

    setPanBlacklisted(false);

    setPanBlocked(false);

    setErrors((e) => ({ ...e, panNumber: '' }));

    try {

      const cached = getPanCache(pan);

      const verifyRes = cached

        ? cached

        : await verifyPan(pan).catch((err) => ({

          responseCode: 'ERR',

          responseMessage:

            err?.response?.data?.message ||

            err?.message ||

            'PAN verification failed',

          data: null,

          raw: err?.response?.data,

        }));

      if (!isCurrent()) return;

      const verifyMsg = apiText(verifyRes);

      const panDoesNotExist =

        String(verifyRes?.responseCode || '').toUpperCase() === 'ENI004' ||

        /no information found|this pan was not found|pan not found|customer not found/i.test(verifyMsg);

      const blacklistRes = await checkPanBlacklist(pan);

      if (!isCurrent()) return;

      const existingRes = await checkExistingCustomerByPan(pan);

      if (!isCurrent()) return;

      if (!isPanVerifySuccess(verifyRes)) {

        setPanVerifiedOk(false);

        setPanWarning('');

        setErrors((e) => ({

          ...e,

          panNumber: panDoesNotExist

            ? 'PAN does not exist. Enter your correct PAN.'

            : panVerifyFailMessage(verifyRes),

        }));

        return;

      }

      if (!cached) setPanCache(pan, verifyRes);

      setPanVerifyPayload(verifyRes);

      const blacklistBlocked =
        blacklistRes?.blacklisted === true ||
        (blacklistRes?.status === true && blacklistRes?.blacklisted !== false);

      if (blacklistBlocked) {

        setPanBlacklisted(true);

        setPanBlocked(true);

        setPanVerifiedOk(false);

        setErrors((e) => ({

          ...e,

          panNumber: apiText(blacklistRes) || 'This PAN is blacklisted. Please contact customer support.',

        }));

        setPanWarning('');

        setPanChecking(false);

        return;

      }

      // Only Reject / Close / Fresh can apply; any other lead status → block

      if (existingRes?.status === true) {

        const d = existingRes.data || {};

        const status = String(

          d.status || d.lead_status || d.leadStatus || ''

        )

          .toUpperCase()

          .trim();

        const allowedStatuses = [

          'CLOSED',

          'CLOSE',

          'REJECT',

          'REJECTED',

          'FRESH',

        ];

        if (!allowedStatuses.includes(status)) {

          setPanBlocked(true);

          setPanVerifiedOk(false);

          setErrors((e) => ({

            ...e,

            panNumber: apiText(existingRes) || `Your loan status is ${status || d.status || 'ACTIVE'}. Cannot re-apply.`,

          }));

          setPanWarning('');

          setPanChecking(false);

          return;

        }

        setPanWarning(apiText(existingRes) || `Latest Status: ${d.status || status} (You can re-apply)`);

      }

      const normalized = cached || verifyRes;

      if (!cached && isPanVerifySuccess(normalized)) {

        setPanCache(pan, normalized);

      }

      setPanVerifyPayload(normalized);

      if (isPanVerifySuccess(normalized)) {

        setPanVerifiedOk(true);

        setPanWarning((prev) => prev || 'PAN verified successfully.');

        const d = normalized.data || {};

        // const nameParts = splitFullName(

        //   d.fullName || d.name || d.full_name || [d.firstName, d.lastName].filter(Boolean).join(' ')

        // );

const fullName = String(

  d.fullName || d.name || d.full_name ||

  [d.firstName, d.lastName].filter(Boolean).join(' ') || ''

).trim();

const nameParts = splitFullName(fullName);

        setProfile((prev) => ({

          ...prev,

          ...nameParts,

          dob: d.dob || d.dateOfBirth || prev.dob,

          gender: String(d.gender || prev.gender || '').toUpperCase(),

          addressFromKyc: d.address || prev.addressFromKyc,

          maskedAadhaar: d.maskedAadhaarNumber || d.masked_aadhaar || prev.maskedAadhaar,

          panName: d.fullName || d.name || prev.panName,

        }));

        if (d.address && !form.address) {

          setForm((f) => ({ ...f, address: String(d.address).slice(0, MAX_ADDRESS_LENGTH) }));

        }

      }

    } catch (err) {

      setPanVerifiedOk(false);

      setErrors((e) => ({

        ...e,

        panNumber: apiText(err?.response?.data) || err?.message || 'PAN check failed. Please try again.',

      }));

    } finally {

      if (panReqRef.current.id === reqId) {

        panReqRef.current.busy = false;

        panReqRef.current.done = true;

        setPanChecking(false);

      }

    }

  }, [form.address]);

  const handlePanBlur = () => {

    if (PAN_PATTERN.test(panNumber)) runPanChecks(panNumber);

  };

  const handleSendOtp = async () => {

    if (otpBusy) return;

    const mobile = String(form.mobile || '').replace(/\D/g, '').slice(-10);

    if (!/^[6-9]\d{9}$/.test(mobile)) {

      setErrors((e) => ({ ...e, mobile: 'Enter valid 10-digit Indian mobile number' }));

      return;

    }

    setOtpBusy(true);

    setOtpInfo('');

    try {

      const resp = await apiSendOtp(mobile);

      const data = resp?.data || {};

      const apiRes = data.api_response || {};

      const ok = apiRes.return === true || data.status === true || data.Status === 1 || data.success === true;

      const message = apiText(data);

      if (ok) {

        verifiedOtpRef.current = '';

        sessionStorage.removeItem('dhanwalle_apply_new_verified_otp');

        setOtpSent(true); setOtpVerified(false); setMobileOtpVerified(false); setOtp('');

        setResendLeft(OTP_RESEND_SECONDS); setOtpSentAt(Date.now()); setOtpInfo(message || 'OTP sent successfully');

        setErrors((e) => ({ ...e, mobile: '', otp: '' }));

      } else setErrors((e) => ({ ...e, mobile: message || 'Failed to send OTP' }));

    } catch (err) {

      console.error('Mobile OTP send error:', err);

      setErrors((e) => ({ ...e, mobile: 'Failed to send OTP. Please try again.' }));

    } finally { setOtpBusy(false); }

  };

  const handleVerifyOtp = async () => {

    if (otpBusy) return;

    const mobile = String(form.mobile || '').replace(/\D/g, '').slice(-10);

    const cleanOtp = String(otp || '').replace(/\D/g, '');

    if (cleanOtp.length < 4) { setErrors((e) => ({ ...e, otp: 'Enter valid OTP' })); return; }

    setOtpBusy(true);

    try {

      const resp = await apiVerifyOtp(mobile, cleanOtp);

      const data = resp?.data || {};

      const apiRes = data.api_response || {};

      const ok = apiRes.return === true || data.status === true || data.Status === 1 || data.success === true;

      const message = apiText(data);

      if (ok) {

        verifiedOtpRef.current = cleanOtp;

        sessionStorage.setItem('dhanwalle_apply_new_verified_otp', cleanOtp);

        setMobileOtpVerified(true); setOtpSent(false); setOtpSentAt(0); setResendLeft(0); setOtp(''); setOtpInfo(message || 'Mobile OTP verified successfully');

        setErrors((e) => ({ ...e, otp: '', mobile: '' }));

        setForm((f) => ({ ...f, mobile }));

      } else setErrors((e) => ({ ...e, otp: message || 'Invalid OTP' }));

    } catch (err) {

      console.error('Mobile OTP verify error:', err);

      setErrors((e) => ({ ...e, otp: 'OTP verification failed. Please try again.' }));

    } finally { setOtpBusy(false); }

  };

  const handleStartDigiLocker = async () => {

    if (digilockerLoading || panChecking) return;

    const next = {};

    if (!mobileOtpVerified) next.mobile = 'Verify your mobile number first';

    if (!PAN_PATTERN.test(panNumber)) next.panNumber = 'Enter a valid PAN (ABCDE1234F)';

    if (panBlacklisted) next.panNumber = 'Customer is blacklisted';

    if (panBlocked && !/re-apply/i.test(panWarning)) next.panNumber = errors.panNumber || 'Cannot proceed with this PAN';

    if (!panVerifiedOk) next.panNumber = next.panNumber || 'Please wait for PAN verification to complete';

    setErrors((e) => ({ ...e, ...next }));

    if (Object.keys(next).length) return;

    setDigilockerLoading(true); setDigilockerError('');

    try {

      const resp = await axios.post('https://dhanwalle.in/loan_backend/sendAadhaarOtp2.php', {}, {

        headers: { 'Content-Type': 'application/json' }, timeout: 30000,

      });

      const data = resp?.data;

      const kycData = data?.data;

      const kycUrl = kycData?.kycUrl;

      const transactionId = kycData?.transactionId;

      if (data?.status !== true || !kycUrl || !transactionId) throw new Error(data?.message || data?.Message || 'Unable to start DigiLocker verification.');

      sessionStorage.setItem('dhanwalle_digilocker_txn', String(transactionId));

      sessionStorage.setItem('dhanwalle_digilocker_pan', panNumber);

      sessionStorage.setItem('dhanwalle_digilocker_mobile', form.mobile);

      window.location.assign(kycUrl);

    } catch (err) {

      console.error('DigiLocker start error:', err);

      setDigilockerError(err?.response?.data?.message || err?.message || 'Unable to start DigiLocker. Please try again.');

    } finally { setDigilockerLoading(false); }

  };

  useEffect(() => {

      const params = new URLSearchParams(window.location.search);

  const txnId =
    params.get('txnId') ||
    sessionStorage.getItem('dhanwalle_digilocker_txn');

  const aadhaarVerified = params.get('aadhaarVerified');

  console.log('DigiLocker callback:', {
    txnIdAvailable: Boolean(txnId),
    aadhaarVerified,
    currentUrl: window.location.href,
  });

  if (!txnId || (aadhaarVerified && aadhaarVerified !== '1')) {
    console.log('DigiLocker KYC API skipped: transaction/callback condition not met');
    return;
  }

  let cancelled = false;

    const fetchDigiLockerDetails = async () => {

      setKycLoading(true); setDigilockerError('');

      try {

        const response = await axios.get(`https://dhanwalle.in/Api/TaskApi/getDigitapKycDetails/${encodeURIComponent(txnId)}`, { timeout: 30000 });

        const result = response?.data;

        const kyc = result?.Data;

        if (result?.Status !== 'Success' || !kyc) throw new Error(result?.Message || result?.message || 'DigiLocker verification was not successful.');

        if (cancelled) return;
        console.log('KYC DATA:', JSON.stringify(kyc, null, 2));

        setKycCompleted(true);

        const fullName = String(

  kyc.customer_name || kyc.name || ''

).trim();

const nameParts = splitFullName(fullName);

        const genderRaw = String(kyc.gender || '').toUpperCase();

        const gender = genderRaw.startsWith('M') ? 'MALE' : genderRaw.startsWith('F') ? 'FEMALE' : genderRaw ? 'OTHER' : '';

const clean = (v) => (v == null ? '' : String(v).trim());

const fullAddressFromApi =
  clean(kyc.full_address) ||
  clean(kyc.address) ||
  clean(kyc.complete_address);

const addressParts = [
  kyc.care_of,
  kyc.house,
  kyc.street,
  kyc.landmark,
  kyc.locality,
  kyc.post_office,
  kyc.vtc,
  kyc.sub_district,
  kyc.district,
  kyc.state,
  kyc.pincode,
]
  .map(clean)
  .filter(Boolean);

const builtAddress = addressParts.join(', ');

const address =
  fullAddressFromApi.length >= builtAddress.length
    ? fullAddressFromApi
    : builtAddress;

        const masked = String(kyc.masked_aadhaar || kyc.masked_aadhaar_number || kyc.maskedAdharNumber || '').trim();

        const returnedPan = sessionStorage.getItem('dhanwalle_digilocker_pan') || '';

        if (returnedPan) {

          setPanNumber(returnedPan);

          const cachedPan = getPanCache(returnedPan);

          if (cachedPan) setPanVerifyPayload(cachedPan);

          setPanVerifiedOk(true);

        }

        setProfile((prev) => ({ ...prev, ...nameParts, dob: kyc.dob || prev.dob, gender: gender || prev.gender, addressFromKyc: address || prev.addressFromKyc, maskedAadhaar: masked || prev.maskedAadhaar }));

    
setForm((f) => ({
  ...f,
  mobile:
    sessionStorage.getItem('dhanwalle_digilocker_mobile') ||
    f.mobile,
  address:
    address && address.length >= MIN_ADDRESS_LENGTH
      ? address.slice(0, MAX_ADDRESS_LENGTH)
      : f.address || address,
}));



        setOtpVerified(true); setMobileOtpVerified(true); setOtpSent(false); setOtpSentAt(0); setResendLeft(0);

        setErrors((e) => ({ ...e, otp: '', panNumber: '' }));

        sessionStorage.removeItem('dhanwalle_digilocker_txn');

        sessionStorage.removeItem('dhanwalle_digilocker_pan');

        sessionStorage.removeItem('dhanwalle_digilocker_mobile');

        window.history.replaceState({}, '', window.location.pathname);

      } catch (err) {

        console.error('DigiLocker details error:', err);

        if (!cancelled) setDigilockerError(err?.response?.data?.Message || err?.message || 'Unable to fetch DigiLocker details. Please try again.');

      } finally { if (!cancelled) setKycLoading(false); }

    };

    fetchDigiLockerDetails();

    return () => { cancelled = true; };

  }, []);

  const updateFormField = (field, value) => {

    setForm((f) => ({ ...f, [field]: value }));

    setErrors((er) => (er[field] ? { ...er, [field]: '' } : er));

  };

  const handleStateSelect = async (opt) => {

    const sid = String(opt.state_id);

    const name = opt.state;

    setStateId(sid);

    setCityId('');

    setCities([]);

    setPincodes([]);

    setForm((f) => ({ ...f, state: name, city: '', pincode: '' }));

    setErrors((e) => ({ ...e, state: '', city: '', pincode: '' }));

    try {

      const resp = await getCities(sid);

      if (resp?.Status === 1 && Array.isArray(resp.Data) && resp.Data.length) {

        setCities(resp.Data);

      } else {

        setCities(getFallbackCities(name));

      }

    } catch {

      setCities(getFallbackCities(name));

    }

  };

  const handleCitySelect = async (opt) => {

    const cid = String(opt.city_id);

    setCityId(cid);

    setPincodes([]);

    setForm((f) => ({ ...f, city: opt.city, pincode: '' }));

    setErrors((e) => ({ ...e, city: '', pincode: '' }));

    if (String(cid).startsWith('local-')) return;

    try {

      const resp = await getPincodesByCityId(cid);

      if (resp?.Status === 1 && Array.isArray(resp.Data)) {

        setPincodes(resp.Data);

      }

    } catch {

      setPincodes([]);

    }

  };

  const validateStep2 = () => {

    const next = {};

    const income = Number(form.monthlyIncome);

    const loan = Number(form.loanAmount);

    const obligations = form.obligations === '' ? 0 : Number(form.obligations);

    if (!income || income < MIN_MONTHLY_INCOME || income > MAX_MONTHLY_INCOME) {

      next.monthlyIncome = `Income must be ₹${MIN_MONTHLY_INCOME.toLocaleString('en-IN')} – ₹${MAX_MONTHLY_INCOME.toLocaleString('en-IN')}`;

    }

    if (!loan || loan < MIN_LOAN_AMOUNT || loan > MAX_LOAN_AMOUNT) {

      next.loanAmount = `Loan must be ₹${MIN_LOAN_AMOUNT.toLocaleString('en-IN')} – ₹${MAX_LOAN_AMOUNT.toLocaleString('en-IN')}`;

    } else if (income && loan > income * 5) {

      next.loanAmount = 'Loan amount cannot exceed 5× monthly income';

    }

    if (form.alternateMobile) {

      if (!/^[6-9]\d{9}$/.test(form.alternateMobile)) {

        next.alternateMobile = 'Enter valid alternate mobile';

      } else if (form.alternateMobile === form.mobile) {

        next.alternateMobile = 'Alternate must differ from mobile';

      }

    }

    // if (!form.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {

    //   next.email = 'Enter valid personal email';

    // }

    // if (form.officialEmail && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.officialEmail)) {

    //   next.officialEmail = 'Enter valid official email';

    // }

    if (!form.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {

      next.email = 'Enter valid personal email';

    }

    if (

      form.officialEmail &&

      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.officialEmail)

    ) {

      next.officialEmail = 'Enter valid official email';

    }

    if (form.obligations !== '') {

      if (Number.isNaN(obligations) || obligations < 0 || obligations > MAX_OBLIGATIONS) {

        next.obligations = 'Invalid obligations amount';

      } else if (income && obligations > income) {

        next.obligations = 'Obligations cannot exceed monthly income';

      }

    }

    if (!stateId || !form.state) next.state = 'Select state';

    if (!form.city) next.city = 'Select city';

    if (!form.pincode || !/^\d{6}$/.test(form.pincode)) next.pincode = 'Select / enter 6-digit pincode';

    if (!form.address || form.address.trim().length < MIN_ADDRESS_LENGTH) {

      next.address = `Address must be at least ${MIN_ADDRESS_LENGTH} characters`;

    } else if (form.address.length > MAX_ADDRESS_LENGTH) {

      next.address = `Address max ${MAX_ADDRESS_LENGTH} characters`;

    }

    if (!form.declarationConsent) {

      next.declarationConsent = 'Please accept the declaration to continue';

    }

    if (!form.notificationConsent) {

      next.notificationConsent = 'Please authorise notifications to continue';

    }

    if (panBlacklisted) next.panNumber = 'Customer is blacklisted';

    return next;

  };

  const scrollToFirstError = (errorMap) => {

    const order = [

      'monthlyIncome',

      'loanAmount',

      'alternateMobile',

      'email',

      'officialEmail',

      'obligations',

      'state',

      'city',

      'pincode',

      'address',

      'declarationConsent',

      'notificationConsent',

      'panNumber',

      'submitNotice',

    ];

    const key = order.find((name) => errorMap[name]);

    if (!key) return;

    window.requestAnimationFrame(() => {

      const el = document.querySelector(`[data-field="${key}"]`);

      if (!el) return;

      el.scrollIntoView({ behavior: 'smooth', block: 'center' });

      const focusable = el.querySelector('input, textarea, select');

      if (focusable && typeof focusable.focus === 'function') {

        focusable.focus({ preventScroll: true });

      }

    });

  };

  const handleSubmit = async (e) => {

    e.preventDefault();

    e.stopPropagation();

    // Sync lock FIRST — double-click / Enter key se second hit block

    if (submitLockRef.current || submitting || submitted) return;

    submitLockRef.current = true;

    const next = validateStep2();

    setErrors(next);

    if (Object.keys(next).length) {

      submitLockRef.current = false;

      scrollToFirstError(next);

      return;

    }

    if (!verifiedOtpRef.current) {

      submitLockRef.current = false;

      const otpError = { submitNotice: 'Please verify OTP again before submitting' };

      setErrors(otpError);

      scrollToFirstError(otpError);

      return;

    }

    setSubmitting(true);

    const cached = getPanCache(panNumber) || panVerifyPayload;

    const panData = cached?.data || {};

    const panOk = cached && isPanVerifySuccess(cached);

    const payload = {

      loan_amount: form.loanAmount,

      monthly_income: form.monthlyIncome,

      first_name: profile.firstName || 'NA',

      middle_name: profile.middleName || null,

      sur_name: profile.lastName || null,

      pan: panNumber,

      pan_status: panOk ? 1 : 0,

      pan_response_code: cached?.responseCode || null,

      pan_message: cached?.responseMessage || null,

      pan_reference_id: cached?.referenceId || null,

      pan_name: panData.fullName || panData.name || profile.panName || null,

      pan_address: panData.address || profile.addressFromKyc || null,

      pan_gender: panData.gender || profile.gender || null,

      pan_dob: panData.dob || profile.dob || null,

      pan_masked_aadhaar:

        panData.maskedAadhaarNumber ||

        panData.maskAadhaarNumber ||

        profile.maskedAadhaar ||

        null,

      dob: profile.dob || null,

      gender: (profile.gender || 'OTHER').toUpperCase(),

      mobile: form.mobile,

      alternate_mobile: form.alternateMobile || null,

      otp: verifiedOtpRef.current,

      email_personal: form.email,

      email_official: form.officialEmail || null,

      obligations: form.obligations || null,

      state_id: stateId,

      city: cityId && !String(cityId).startsWith('local-') ? cityId : form.city,

      city_id: cityId && !String(cityId).startsWith('local-') ? cityId : null,

      pin: form.pincode,

      pincode: form.pincode,

      address: form.address.trim(),

      term_and_condition: form.declarationConsent ? 'YES' : 'NO',

      ip: null,

      coordinates: null,

      source: 'Fundswall',

      lead_data_source_id: 39,

      utm_source: '',

      utm_campaign: null,

      selfie_image_url: null,

      aadhaar_number: null,

      aadhaar_last_four: (String(profile.maskedAadhaar || '').match(/\d{4}(?!.\*\d)/) || [])[0] || null,

    };

    try {

      const resp = await saveLendingPage(payload);

      if (isLeadSaveSuccess(resp)) {

        const inserted =

          resp.inserted_id ||

          resp.InsertedId ||

          resp.Data?.inserted_id ||

          resp.data?.inserted_id ||

          resp.lead_id ||

          resp.Data?.lead_id ||

          Date.now();

        setRefId(`FW${inserted}`);

        clearPanCache();

        sessionStorage.removeItem('dhanwalle_apply_new_verified_otp');

        verifiedOtpRef.current = '';

clearApplyDraft();

        setSubmitted(true);

        // Success: lock rahe — dubara submit nahi

        return;

      }

      submitLockRef.current = false;

      setSubmitting(false);

      alert(

        apiText(resp) || 'Submit failed'

      );

    } catch (err) {

      submitLockRef.current = false;

      setSubmitting(false);

      alert(apiText(err?.response?.data) || err?.message || 'Submit failed. Please try again.');

    }

  };

  if (submitted) {

    return (

      <main className="apn-page">

        <section className="apn-success-card">

          <div className="apn-confetti" aria-hidden="true">

            {Array.from({ length: 24 }).map((_, i) => (

              <span key={i} className={`apn-confetti-piece p${i % 6}`} />

            ))}

          </div>

          <div className="apn-success-icon"><FaCheckCircle /></div>

          <h1>Application Submitted!</h1>

          <p className="apn-ref">Reference ID: <strong>{refId}</strong></p>

          <ul className="apn-next-steps">

            <li>Our team will review your application shortly.</li>

            <li>Keep your Aadhaar-linked mobile reachable for verification.</li>

            <li>You may receive a call or SMS with next steps.</li>

          </ul>

          <div className="apn-success-actions">

            <Link to="/" className="apn-btn-secondary"><FaHome /> Home</Link>

            <a href="tel:+919211460800" className="apn-btn"><FaPhoneAlt /> Call Us</a>

          </div>

        </section>

      </main>

    );

  }

  return (

    <main className="apn-page">

      {submitting && (

        <div className="apn-overlay">

          <Spinner animation="border" />

          <p>Submitting your application… Please wait, do not refresh or click again.</p>

        </div>

      )}

      <section className={`apn-card ${otpVerified ? 'apn-card-wide' : ''}`}>

        <aside className="apn-left">

          <div className="apn-left-visual">

            <img className="apn-left-photo" src={applyNowImage} alt="Personal loan" />

          </div>

          <div className="apn-left-content">

            <h2>Personal Loan in minutes</h2>

            <p>Verify your mobile, PAN and DigiLocker KYC, then complete a short application.</p>

            <ul>

              <li><FaCheck /> Secure DigiLocker KYC</li>

              <li><FaCheck /> 100% paperless process</li>

              <li><FaCheck /> Transparent charges</li>

            </ul>

          </div>

        </aside>

        <div className="apn-right">

          {/* <div className="apn-steps">

            <div className={`apn-step ${otpVerified ? 'done' : 'active'}`}>

              <span>{otpVerified ? <FaCheck /> : '1'}</span>

              <div><small>Step 1</small><strong>Mobile &amp; KYC</strong></div>

            </div>

            <span className={`apn-track ${otpVerified ? 'filled' : ''}`} />

            <div className={`apn-step ${otpVerified ? 'active' : ''}`}>

              <span>2</span>

              <div><small>Step 2</small><strong>Application</strong></div>

            </div>

          </div> */}

   <div className="apn-steps">

  <div

    className={`apn-step ${

      mobileOtpVerified ? 'done' : 'active'

    }`}

  >

    <span>

      {mobileOtpVerified ? <FaCheck /> : '1'}

    </span>

    <div>

      <small>Step 1</small>

      <strong>Mobile &amp; OTP</strong>

    </div>

  </div>

  <span

    className={`apn-track ${

      mobileOtpVerified ? 'filled' : ''

    }`}

  />

  <div

    className={`apn-step ${

      kycCompleted ? 'done' : mobileOtpVerified ? 'active' : ''

    }`}

  >

    <span>

      {kycCompleted ? <FaCheck /> : '2'}

    </span>

    <div>

      <small>Step 2</small>

      <strong>PAN &amp; DigiLocker</strong>

    </div>

  </div>

  <span

    className={`apn-track ${

      kycCompleted ? 'filled' : ''

    }`}

  />

  <div

    className={`apn-step ${

      submitted ? 'done' : kycCompleted ? 'active' : ''

    }`}

  >

    <span>

      {submitted ? <FaCheck /> : '3'}

    </span>

    <div>

      <small>Step 3</small>

      <strong>Application</strong>

    </div>

  </div>

</div>

          <h1>{otpVerified ? 'Application details' : !mobileOtpVerified ? 'Verify your mobile' : 'Verify your PAN'}</h1>

          <p className="apn-sub">

            {otpVerified

              ? 'Complete loan and contact details to submit'

              : !mobileOtpVerified ? 'Enter your mobile number and verify OTP' : 'Verify PAN and continue with DigiLocker KYC'}

          </p>

          <Form noValidate onSubmit={handleSubmit}>

            {!otpVerified && (

              <>

                {!mobileOtpVerified && (

                  <>

                    <div className="apn-field">

                      <label>Mobile Number <em>*</em></label>

                      <div className={`apn-input ${errors.mobile ? 'has-error' : ''}`}>

                        <FaPhoneAlt />

                        <input type="tel" inputMode="numeric" maxLength={10} value={form.mobile} placeholder="10-digit mobile number"

                          onChange={(e) => { const mobile = e.target.value.replace(/\D/g, '').slice(0, 10); setForm((f) => ({ ...f, mobile })); setOtpSent(false); setOtpSentAt(0); setResendLeft(0); setOtp(''); setErrors((er) => ({ ...er, mobile: '', otp: '' })); }} autoComplete="tel" />

                      </div>

                      {errors.mobile && <div className="apn-error">{errors.mobile}</div>}

                    </div>

                    {!otpSent ? (

                      <Button type="button" className="apn-btn apn-btn-compact" disabled={otpBusy} onClick={handleSendOtp}>{otpBusy ? 'Sending…' : <>Send OTP <FaArrowRight /></>}</Button>

                    ) : (

                      <div className="apn-otp-box">

                        <div className="apn-info"><FaShieldAlt /> OTP sent to {form.mobile} {otpInfo ? `· ${otpInfo}` : ''}</div>

                        <div className="apn-field"><label>Enter Mobile OTP <em>*</em></label>

                          <div className={`apn-input ${errors.otp ? 'has-error' : ''}`}><FaLock /><input type="text" inputMode="numeric" maxLength={6} value={otp} placeholder="Enter OTP" onChange={(e) => { setOtp(e.target.value.replace(/\D/g, '').slice(0, 6)); setErrors((er) => ({ ...er, otp: '' })); }} /></div>

                          {errors.otp && <div className="apn-error">{errors.otp}</div>}

                        </div>

                        <Button type="button" className="apn-btn apn-btn-compact" disabled={otpBusy} onClick={handleVerifyOtp}>{otpBusy ? 'Verifying…' : <>Verify OTP <FaArrowRight /></>}</Button>

                        <button type="button" className="apn-resend" disabled={resendLeft > 0 || otpBusy} onClick={handleSendOtp}>{resendLeft > 0 ? `Resend OTP in ${resendLeft}s` : "Didn't receive OTP? Resend"}</button>

                      </div>

                     )}

                  </>

                )}

                {mobileOtpVerified && (

                  <>

                    <div className="apn-info"><FaCheckCircle /> Mobile number verified: {form.mobile}</div>

                    <div className="apn-field"><label>PAN Number <em>*</em></label>

                      <div className={`apn-input ${errors.panNumber ? 'has-error' : ''} ${panVerifiedOk ? 'is-ok' : ''}`}><FaIdCard />

                        {/* <input type="text" maxLength={10} value={panNumber} placeholder="ABCDE1234F"

                          // onChange={(e) => { const v = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, ''); setPanNumber(v); setPanVerifiedOk(false); setPanBlacklisted(false); setPanBlocked(false); setPanWarning(''); setDigilockerError(''); setErrors((er) => ({ ...er, panNumber: '' })); }} onBlur={handlePanBlur} autoComplete="off" />

                          onChange={(e) => {

                            const v = e.target.value

                              .toUpperCase()

                              .replace(/[^A-Z0-9]/g, '')

                              .slice(0, 10);

                            setPanNumber(v);

                            setOtpSent(false);

                            setOtpVerified(false);

                            setOtp('');

                            setPanVerifiedOk(false);

                            setPanBlacklisted(false);

                            setPanBlocked(false);

                            setPanWarning('');

                            setErrors((er) => ({ ...er, panNumber: '' }));

                            // Automatically call PAN verification after 10 valid characters

                            if (PAN_PATTERN.test(v)) {

                              runPanChecks(v);

                            }

                          }}

                          autoComplete="off" /> */}

<input

  type="text"

  maxLength={10}

  value={panNumber}

  placeholder="ABCDE1234F"

  onChange={(e) => {

    const v = e.target.value

      .toUpperCase()

      .replace(/[^A-Z0-9]/g, '')

      .slice(0, 10);

    setPanNumber(v);

    setPanVerifiedOk(false);

    setPanBlacklisted(false);

    setPanBlocked(false);

    setPanWarning('');

    setDigilockerError('');

    setErrors((er) => ({ ...er, panNumber: '' }));

    if (PAN_PATTERN.test(v)) {

      runPanChecks(v);

    }

  }}

  autoComplete="off"

/>

                        {panChecking && <Spinner size="sm" animation="border" />}{panVerifiedOk && !panChecking && <FaCheckCircle className="ok" />}

                      </div>

                      {errors.panNumber && <div className="apn-error">{errors.panNumber}</div>}

                      {panWarning && !errors.panNumber && <div className={/re-apply|verified successfully|you can continue/i.test(panWarning) ? 'apn-ok-msg' : 'apn-warn-msg'}>{panWarning}</div>}

                    </div>

                    <Button type="button" className="apn-btn apn-btn-compact" disabled={digilockerLoading || kycLoading || panChecking || panBlacklisted || panBlocked || !panVerifiedOk} onClick={handleStartDigiLocker}>{digilockerLoading ? 'Connecting to DigiLocker…' : <>Continue with DigiLocker <FaArrowRight /></>}</Button>

                    {kycLoading && <div className="apn-info"><Spinner size="sm" animation="border" /> Fetching your KYC details…</div>}

                    {digilockerError && <div className="apn-error">{digilockerError}</div>}

                  </>

                )}

              </>

            )}

            {otpVerified && (

              <div className="apn-step2">

                <div className="apn-grid apn-step2-fields">

<div className="apn-field">

  <label>Full Name <em>*</em></label>

  <input

    className="apn-plain"

    type="text"

    value={[

      profile.firstName,

      profile.middleName,

      profile.lastName,

    ].filter(Boolean).join(" ")}

    onChange={(e) => {

      const nameParts = splitFullName(e.target.value);

      setProfile((prev) => ({

        ...prev,

        ...nameParts,

      }));

    }}

    placeholder="Enter full name"

    required

  />

</div>

                  <div className="apn-field" data-field="monthlyIncome">

                    <label>Monthly Income <em>*</em></label>

                    <input

                      className="apn-plain"

                      type="number"

                      value={form.monthlyIncome}

                      onChange={(e) => updateFormField('monthlyIncome', e.target.value)}

                      placeholder="Min ₹30,000"

                    />

                    {errors.monthlyIncome && <div className="apn-error">{errors.monthlyIncome}</div>}

                  </div>

                  <div className="apn-field" data-field="loanAmount">

                    <label>Loan Amount <em>*</em></label>

                    <input

                      className="apn-plain"

                      type="number"

                      value={form.loanAmount}

                      onChange={(e) => updateFormField('loanAmount', e.target.value)}

                      placeholder="₹10,000 – ₹1,00,000"

                    />

                    {errors.loanAmount && <div className="apn-error">{errors.loanAmount}</div>}
                  </div>

                  <div className="apn-field" data-field="alternateMobile">

                    <label>Alternate Mobile</label>

                    <input

                      className="apn-plain"

                      type="tel"

                      maxLength={10}

                      value={form.alternateMobile}

                      onChange={(e) =>

                        updateFormField(

                          'alternateMobile',

                          e.target.value.replace(/\D/g, '').slice(0, 10)

                        )

                      }

                    />

                    {errors.alternateMobile && (

                      <div className="apn-error">{errors.alternateMobile}</div>

                    )}

                  </div>

                  <div className="apn-field" data-field="email">

                    <label>Personal Email <em>*</em></label>

                    <input

                      className="apn-plain"

                      type="email"

                      value={form.email}

                      onChange={(e) => updateFormField('email', e.target.value)}

                    />

                    {errors.email && <div className="apn-error">{errors.email}</div>}

                  </div>

                  <div className="apn-field" data-field="officialEmail">

                    <label>Official Email</label>

                    <input

                      className="apn-plain"

                      type="email"

                      value={form.officialEmail}

                      onChange={(e) => updateFormField('officialEmail', e.target.value)}

                    />

                    {errors.officialEmail && (

                      <div className="apn-error">{errors.officialEmail}</div>

                    )}

                  </div>

                  <div className="apn-field" data-field="obligations">

                    <label>Obligations</label>

                    <input

                      className="apn-plain"

                      type="number"

                      value={form.obligations}

                      onChange={(e) => updateFormField('obligations', e.target.value)}

                    />

                    {errors.obligations && <div className="apn-error">{errors.obligations}</div>}

                  </div>

                  <SearchableSelect

                    label="State"

                    required

                    value={stateId}

                    displayValue={form.state}

                    options={states}

                    placeholder="Search state"

                    error={errors.state}

                    fieldName="state"

                    getOptionLabel={(o) => o.state}

                    getOptionValue={(o) => o.state_id}

                    onSelect={handleStateSelect}

                  />

                  <SearchableSelect

                    label="City"

                    required

                    value={cityId}

                    displayValue={form.city}

                    options={cities}

                    placeholder="Search city"

                    disabled={!stateId}

                    error={errors.city}

                    fieldName="city"

                    getOptionLabel={(o) => o.city}

                    getOptionValue={(o) => o.city_id}

                    onSelect={handleCitySelect}

                  />

                  <SearchableSelect

                    label="Pincode"

                    required

                    value={form.pincode}

                    displayValue={form.pincode}

                    options={

                      pincodes.length

                        ? pincodes

                        : form.pincode

                          ? [{ m_pincode_id: form.pincode, m_pincode_value: form.pincode }]

                          : []

                    }

                    placeholder={pincodes.length ? 'Search pincode' : 'Type 6-digit pincode'}

                    disabled={!form.city}

                    error={errors.pincode}

                    fieldName="pincode"

                    getOptionLabel={(o) => o.m_pincode_value || o}

                    getOptionValue={(o) => o.m_pincode_value || o}

                    onSelect={(o) => {

                      const pin = o.m_pincode_value || String(o);

                      updateFormField('pincode', pin);

                    }}

                  />

                </div>

                {!pincodes.length && form.city && (

                  <div className="apn-field" data-field="pincode">

                    <label>Enter Pincode <em>*</em></label>

                    <input

                      className="apn-plain"

                      type="text"

                      inputMode="numeric"

                      maxLength={6}

                      value={form.pincode}

                      onChange={(e) =>

                        updateFormField(

                          'pincode',

                          e.target.value.replace(/\D/g, '').slice(0, 6)

                        )

                      }

                      placeholder="6-digit pincode"

                    />

                    {errors.pincode && <div className="apn-error">{errors.pincode}</div>}

                  </div>

                )}

                <div className="apn-field" data-field="address">

                  <label>Address <em>*</em></label>

                  <textarea

                    className="apn-plain apn-textarea"

                    rows={2}

                    maxLength={MAX_ADDRESS_LENGTH}

                    value={form.address}

                    onChange={(e) => updateFormField('address', e.target.value)}

                    placeholder="Full residential address (min 15 characters)"
                  />

                  <div className="apn-hint">

                    {form.address.length}/{MAX_ADDRESS_LENGTH}

                  </div>

                  {errors.address && <div className="apn-error">{errors.address}</div>}

                </div>

                <div className="apn-consent-block">

                  <label className="apn-check" data-field="declarationConsent">

                    <input

                      type="checkbox"

                      checked={form.declarationConsent}

                      onChange={(e) =>

                        updateFormField('declarationConsent', e.target.checked)
                      }
                    />

                    <span>

                      I hereby declare that all the above information provided by me is

                      true, correct, and verified to the best of my knowledge.

                      <em> *</em>

                    </span>

                  </label>

                  {errors.declarationConsent && (

                    <div className="apn-error">{errors.declarationConsent}</div>

                  )}

                  <label className="apn-check" data-field="notificationConsent">

                    <input

                      type="checkbox"

                      checked={form.notificationConsent}

                      onChange={(e) =>

                        updateFormField('notificationConsent', e.target.checked)

                      }

                    />

                    <span>

                      I hereby authorise to send notifications via SMS, Email, RCS and

                      others as per{' '}

                      <a href="/terms-conditions" target="_blank" rel="noreferrer">

                        Terms of Service

                      </a>

                      /

                      <a href="/privacy-policy" target="_blank" rel="noreferrer">

                        Privacy Policy

                      </a>

                      <em> *</em>

                    </span>

                  </label>

                  {errors.notificationConsent && (

                    <div className="apn-error">{errors.notificationConsent}</div>

                  )}

                </div>

                {errors.submitNotice && (

                  <div className="apn-error" data-field="submitNotice">{errors.submitNotice}</div>

                )}

                <Button

                  type="submit"

                  className="apn-btn"

                  disabled={submitting || submitted || panBlacklisted}

                  onClick={(e) => {

                    if (submitLockRef.current || submitting || submitted) {

                      e.preventDefault();

                      e.stopPropagation();

                    }

                  }}

                >

                  {submitting ? 'Submitting…' : <>Submit Application <FaArrowRight /></>}

                </Button>

              </div>

            )}

          </Form>

          <div className="apn-trust">

            <span><FaLock /> 256-bit encryption</span>

            <span>No paperwork</span>

            <span>No hidden charges</span>

          </div>

        </div>

      </section>

    </main>

  );

};

export default ApplyNew;